import React, {useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Form,
  Table,
  Input,
  Button,
  InputGroup,
  Label,
} from "reactstrap";
import { Grid } from '@mui/material';
import styles from "./Leads.module.scss"


// Redux
import { connect, useDispatch} from "react-redux";
import { withRouter, Link, useHistory} from "react-router-dom";


//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";
import Pagination from "../../components/Common/Pagination";
import Loader from "../../components/Common/Loader";

//Action
import { leadsList , leadsFilter} from "../../store/leads/actions";


const Leads = (props) => {
    const dispatch= useDispatch();
const history= useHistory();
const user = JSON.parse(localStorage.getItem("user"))
const groups =String(user.groups);

const [checked, setchecked] = useState(false);

const changeLista = (e) => {
  setchecked(e.target.checked)
}

const [search, setSearch] = useState("");

const onChange = (e) => {
    setSearch(e.target.value);
  };
  
  const onSubmit = (e) => {
    e.preventDefault();
    // dispatch(contactsFilter(`?search=${search}`));
  };
  
  const resetSearch = () => {
    // dispatch(contactsFilter(`?search=`));
    setSearch("");
  };
  
  
  useEffect(() => {
  
    dispatch(leadsList());
  
  },[dispatch]);

  const handleShow = (id) =>{ 
    history.push(`/leads/${id}/leads_detail`);
    }
  
  const params = {
    count: props.leads.count,
    next: props.leads.next,
    previous: props.leads.previous,
    results: props.leads.results,
  };

console.log(params)
    return ( 
        <React.Fragment>
             <div className="page-content">
                <MetaTags>
                    <title>tccontrol | Pre-Contactos</title>
                </MetaTags>
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumb title={"tccontrol"} breadcrumbItem={"Pre-Contactos"} />
                            {props.loading ? (
                            <Loader />
                            ) : (
                                <div> 
                                    {/* Card Del boton y filtro */}
                                     <Card >
                                     <CardBody>
                                         <Row>
                                         <Col md={7}>
                                                                    {groups.includes("SuperAdmin") ||  groups.includes("Supervisor") || groups.includes("Operador") || groups.includes("Crear y modificar Cliente") ?(
                                                                        <>
                                                                        
                                                                        <Link
                                                                        className="btn mx-2 btn-primary waves-effect waves-light"
                                                                        to="/contact/add_pre_contact"
                                                                        >
                                                                        Agregar Pre-Contacto{" "}
                                                                        <span className="bx bx-user-plus fa-lg align-middle"></span>
                                                                        </Link>
                                                                        </>
                                                                        


                                                                    ):null}
                                        </Col>
                                        <Col md={5}>
                                            <Form
                                            className="search-box"
                                            onSubmit={onSubmit}
                                            >

                                            <InputGroup>
                                                <Input
                                                type="text"
                                                className="form-control"
                                                name="search"
                                                placeholder="Buscar"
                                                value={search}
                                                onChange={onChange}
                                                
                                                />
                                                <i className="bx bx-search-alt search-icon" />
                                                <Button color="primary" onClick={resetSearch}>
                                                <span className=" bx bx-x fa-lg align-middle"></span>
                                                </Button>
                                            </InputGroup>
                                            </Form>
                                        </Col>
                                        </Row>
                                    </CardBody>
                                     </Card>

                                    < Pagination
                                    count={params.count}
                                    next={params.next}
                                    previous={params.previous}
                                    limit={10}
                                    baseUrl="leads/leads"
                                    filterFunction={leadsFilter}
                                    />


                                    {/* Card de la comprobacion y tabla */}

                                    <Card>
                    <div className="form-check form-switch mb-3">
                        <input className="form-check-input mt-3 mx-1" type="checkbox" id="flexSwitchCheckChecked" onChange={changeLista} checked = {checked} />
                        <Label className="form-check-label mt-3 " for="flexSwitchCheckChecked">Ver en Lista</Label>
                    </div>


            {params.count !== 0 ? (
                <CardBody className="pb-0">
                  <h4 className="card-title">Contacto</h4>
                  {checked && ( 
                  <div className="table-responsive">
                    <Table
                      className="table table-bordered table-striped mb-3 text-center"
                      hover
                    >
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>telefono</th>
                          <th>Nombre del Contacto</th>
                          <th>Direccion</th>
                          
                          
                        </tr>
                      </thead>
                      <tbody>
                          {params.results &&
                            params.results.map((leads, idx) => (
                              <tr key={idx}>
                                <th scope="row">{idx}</th>
                                <td>{leads.phone}</td>

                                <td>
                                {leads.get_full_name === " - " ? leads.razon_social : leads.get_full_name}</td>                                
                                
                                
                                
                                <td>{leads.address}</td>
                              
                              

                              </tr>
                            ))} 
                        </tbody>
                      
                    </Table>


                  </div>
                  )}
                
                  {!checked && (
              
              <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} className='p-5 pt-2'>
                
                {params.results && params.results.map((leads,idx) => ( 
                  

                      <Grid  item   md={4} key ={idx} >    
                        <div className = {`${styles.card}`} onClick={() => handleShow(leads.id)} >

                            <div className={`${styles['card-details']}`}>                            
                                <h3 className="text-primary"> {leads.get_full_name === " - " ? leads.razon_social : leads.get_full_name}</h3> 
                                <div className="text-primary mt-3 "><strong> Telefono</strong></div> 
                                <div>{leads.phone}</div>      
                                <div className="text-primary mb-6"><strong>Direccion</strong> </div>
                                <div>{leads.address}</div>
                                <div>                                  
                                  
                                </div>  
                            </div>  
                        </div>                
                      </Grid>
                  ))}
                  </Grid>
                  )}


                </CardBody>
          ) : ( 
                <CardBody>
                  <h4 className="card-title">No se encontraron resultados</h4>
                </CardBody>
          )}

            </Card>
                                </div>

                                )}
                </Container>
            </div>
        </React.Fragment>
     );
}
 
const mapStateToProps = (state) => {
    const { error, loading, leads } = state.Leads;
    return { error, loading, leads };
  };
  
  export default withRouter(connect(mapStateToProps)(Leads));